var exports = {
  "pC": "thinking___ArGBg",
  "f1": "copilotStart__5qxV-1",
  "Ku": "copilotRun__r74m0x",
  "KA": "copilotEnd__IsIZJ0",
};

module.exports = exports;
